export class StringUtil {
    static IsInteger(str: string): boolean {
        const parsedInt = parseInt(str, 10);
        return !isNaN(parsedInt);
    }

    static CapitalizeFirstLetter(input: string): string {
        if (input.length === 0) {
            return input;
        }

        const firstLetter = input.charAt(0).toUpperCase();
        const restOfTheString = input.slice(1);

        return firstLetter + restOfTheString;
    }

    static ValidateUserName = (userName: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(userName)) return true;
        return false;
    };

    static ValidateEmail = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(email)) return true;
        return false;
    };

    static StripHTML = (htmlData: string): string => {
        let nonHTMLData: string;
        nonHTMLData = htmlData.substring(0,100).replace(/<(?:.|\n)*?>/gm, '');
        return nonHTMLData;
    };

    static RedactTenantConnString = (connStringData: string): string => {
        let redactedConnStringData: string;
        let arrConnStringData = connStringData.split(';')
        redactedConnStringData = arrConnStringData.slice(0, 3).join(';');
        return redactedConnStringData;
    };
}
